module.exports = __webpack_public_path__ + "us-flag.svg";